module.exports = fox._r("images/warning.png", __webpack_public_path__ + "_/_/_/common/frame/images/warning.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/warning.png
// module id = 155
// module chunks = 2